export const hasInput = function hasInput() {
  let returnHasInput = false;
  this.consideration.forEach((input) => {
    if (Object.prototype.hasOwnProperty.call(input, 'input')) {
      returnHasInput = true;
    }
  });
  return returnHasInput;
};
export const displayValue = function displayValue() {
  return this.consideration.map((input) => {
    if (Object.prototype.hasOwnProperty.call(input, 'input')) {
      return `${input.value} ${input.input} `;
    }
    return `${input.value}`;
  }).join('');
};

export const considerations = [
  {
    hasInput,
    displayValue,
    consideration: [
      {
        value: 'the trustee has particular expertise in this type of investment. Leveraging that expertise will enhance the fund\'s ability to maximise members\' retirement benefits',
      },
    ],
  },
  {
    hasInput,
    displayValue,
    consideration: [
      {
        value: 'the trustee wishes to take advantage of current opportunities to achieve strong returns in this area, relative to other asset classes',
      },
    ],
  },
  {
    hasInput,
    displayValue,
    consideration: [
      {
        value: 'the trustee will limit the fund\'s exposure to this type of investment to',
        input: 0,
      },
      {
        value: '% of the overall assets to manage risk',
      },
    ],
  },
  {
    hasInput,
    displayValue,
    consideration: [
      {
        value: 'other',
      },
    ],
  },
];
